import { useEffect } from 'react';
import axeRegister from '../axe';

/**
 * Custom hook to initialize accessibility testing from within any component
 *
 * @param options - pass thru configuration options for @axe-core/react
 */
const useA11yAuditor = options => {
	useEffect(() => {
		axeRegister(options?.context, options?.config);
	});
};

export default useA11yAuditor;
